import { initColorSelect, doAjax, updateTableValue, initRedPointLogic } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'


const initInteriorSeatBeltsCustomizing = () => {
	initColorSelect()
	const isFz8Q7Q9 = aeo['configuration']['FZ8_Q7Q9'] === true
	const isFz9Q7Q9 = aeo['configuration']['FZ9_Q7Q9'] === true
	const loadOptions = (isFz8Q7Q9 || isFz9Q7Q9) ? {} : {}
	loadAlreadyCustomizedOptions(() => {}, loadOptions)
	const setYTO = aeo['configuration']['YTO'] === true
	const setYTQ_A6 = aeo['configuration']['YTQ_A6'] === true
	const setYTQ = aeo['configuration']['YTQ'] === true
	const setYTO_Q7Q8 = aeo['configuration']['YTO_Q7Q8'] === true
	const setYTQ_Q7Q8 = aeo['configuration']['YTQ_Q7Q8'] === true
	const setYTO_A8 = aeo['configuration']['YTO_A8'] === true
	const setFZ9 = aeo['configuration']['FZ9'] === true
	const setFZ9_A5 = aeo['configuration']['FZ9_A5'] === true
	const setFZ8_A5 = aeo['configuration']['FZ8_A5'] === true
	const setFZ9_A6etron = aeo['configuration']['FZ9_A6etron'] === true
	const setFZ8_A6etron = aeo['configuration']['FZ8_A6etron'] === true
	const setFZ9_A6_C9 = aeo['configuration']['FZ9_A6_C9'] === true
	const setFZ8_A6_C9 = aeo['configuration']['FZ8_A6_C9'] === true
	const setFZ8_Q7_Q9 = aeo['configuration']['FZ8_Q7Q9'] === true
	const setFZ9_Q7_Q9 = aeo['configuration']['FZ9_Q7Q9'] === true

	if (setYTQ) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage)
	} else if (setYTQ_A6) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage)
	} else if (setYTO) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage)
	} else if (setYTO_Q7Q8) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage)
	} else if (setYTQ_Q7Q8) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage)
	} else if (setYTO_A8) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage)
	} else if (setFZ9) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage)
	} else if (setFZ9_A5) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage);
	} else if (setFZ8_A5) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage);
	} else if (setFZ9_A6etron) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage);
	} else if (setFZ8_A6etron) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage);
	} else if (setFZ9_A6_C9) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage);
	} else if (setFZ8_A6_C9) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage);
	} else if (setFZ8_Q7_Q9) {
		initRedPointLogic('seatbeltFull', 'dot_seatbeltfull', setImage);	
	} else if (setFZ9_Q7_Q9) {
		initRedPointLogic('seatbelt', 'dot_seatbelt', setImage);
	}
}

function setImage(component, colorCode) {
	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	
	const setYTO = aeo['configuration']['YTO'] === true
	const setYTQ_A6 = aeo['configuration']['YTQ_A6'] === true
	const setYTQ = aeo['configuration']['YTQ'] === true
	const setYTO_Q7Q8 = aeo['configuration']['YTO_Q7Q8'] === true
	const setYTQ_Q7Q8 = aeo['configuration']['YTQ_Q7Q8'] === true
	const setYTO_A8 = aeo['configuration']['YTO_A8'] === true
	const setFZ9 = aeo['configuration']['FZ9'] === true
	const setFZ9_A5 = aeo['configuration']['FZ9_A5'] === true
	const setFZ8_A5 = aeo['configuration']['FZ8_A5'] === true
	const setFZ9_A6etron = aeo['configuration']['FZ9_A6etron'] === true
	const setFZ8_A6etron = aeo['configuration']['FZ8_A6etron'] === true
	const setFZ9_A6_C9 = aeo['configuration']['FZ9_A6_C9'] === true
	const setFZ8_A6_C9 = aeo['configuration']['FZ8_A6_C9'] === true
	const setFZ8_Q7_Q9 = aeo['configuration']['FZ8_Q7Q9'] === true
	const setFZ9_Q7_Q9 = aeo['configuration']['FZ9_Q7Q9'] === true

	//const imageSourceFront = aeo['images']['seatbelt_front_view'][colorCode]
	//const imageSourceBack = aeo['images']['seatbelt_back_view'][colorCode]


	if (setYTQ) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTQ_front_view'][colorCode]		
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_etron_back_view'][colorCode]

	} else if (setYTQ_A6) {		
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTQ_A6_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTQ_A6_back_view'][colorCode]
	} else if (setYTO) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTO_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_back_view'][colorCode]
		if ((frontSeatModel == 'Q4Q_RS') || (frontSeatModel == 'Q4Q')) {
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_RS_back_view'][colorCode]	
		}

	} else if (setYTO_Q7Q8) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTO_Q7Q8_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_Q7Q8_back_view'][colorCode]

		/*
		if (frontSeatModel == 'Q4Q_RS') {
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_RS_back_view'][colorCode]	
		}
		*/

	} else if (setYTQ_Q7Q8) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTQ_Q7Q8_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTQ_Q7Q8_back_view'][colorCode]

		/*
		if (frontSeatModel == 'Q4Q_RS') {
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_RS_back_view'][colorCode]	
		}
		*/

	} else if (setYTO_A8) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_YTO_A8_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_YTO_A8_back_view'][colorCode]

	} else if (setFZ9) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_back_view'][colorCode]
		if (frontSeatModel == 'Q4Q_AU41X_PERF') { // SQ6 etron Performance
			var imageSourceBack = aeo['images']['seatbelt_' + frontSeatModel + '_' + backSeatModel + '_FZ9_back_view'][colorCode]
		}

	} else if (setFZ9_A5) {
		if (carModel == 46 || carModel == 47) {
			var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_A5_RS5_front_view'][colorCode]
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_A5_RS5_back_view'][colorCode]
		} else {
			var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_A5_front_view'][colorCode]
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_A5_back_view'][colorCode]
		}
	} else if (setFZ8_A5) {
		if (carModel == 46 || carModel == 47) {
			var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ8_A5_RS5_front_view'][colorCode]
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_A5_RS5_back_view'][colorCode]
		} else {
			var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ8_A5_front_view'][colorCode]
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_A5_back_view'][colorCode]
		}

	} else if (setFZ9_A6etron) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_A6etron_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_A6etron_back_view'][colorCode]
	} else if (setFZ8_A6etron) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ8_A6etron_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_A6etron_back_view'][colorCode]

	} else if (setFZ9_A6_C9) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_A6_C9_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_A6_C9_back_view'][colorCode]
	} else if (setFZ8_A6_C9) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ8_A6_C9_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_A6_C9_back_view'][colorCode]

	} else if (setFZ8_Q7_Q9) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ8_Q7Q9_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_Q7Q9_back_view'][colorCode]
		if (carModel == 118 || carModel == 119 || carModel == 120) {
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ8_Q9_back_view'][colorCode]
		}
	
	} else if (setFZ9_Q7_Q9) {
		var imageSourceFront = aeo['images']['seatbelt_' + frontSeatModel + '_FZ9_Q7Q9_front_view'][colorCode]
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_Q7Q9_back_view'][colorCode]
		if (carModel == 118 || carModel == 119 || carModel == 120) {
			var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_FZ9_Q9_back_view'][colorCode]
		}
	}
	
	if (carModel <= 2) { 
		var imageSourceBack = aeo['images']['seatbelt_' + backSeatModel + '_etron_back_view'][colorCode];
	} 

	replaceImage(imageSourceFront, component, 'car_frontseat')
	if (carModel <= 2) { 
		
		replaceImage(imageSourceBack, component, 'car_backseat')
	} else {
		replaceImage(imageSourceBack, component, 'car_backseat')
	}

	updateTableValue(component, colorCode, 'interior-seatbelt-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}


export { initInteriorSeatBeltsCustomizing };